module.exports = "/assets/data/e2bfcf1de3ccc76d9a89fd753a332477-BT4.data.json";